import React from 'react';
import Icon from '../../Common/Icon';
import { CORE_LOOP_GROUPS } from '../../../content/helpGuidanceContent';

const LandingHowItWorks = React.memo(() => (
  <section id="loop" className="landing-loop-section">
    <div className="landing-template-frame landing-loop-frame">
      <div className="landing-loop-intro">
        <h2>The ThryveLoop</h2>
        <p>A simple experiment loop that turns curiosity into clarity.</p>
      </div>

      <div className="landing-loop-timeline" aria-label="ThryveLoop experiment loop">
        {CORE_LOOP_GROUPS.map((step, index) => (
          <React.Fragment key={step.title}>
            <div className="landing-loop-step">
              <span className={`landing-loop-step-number landing-loop-step-number--${index + 1}`}>{step.number}</span>
              <h3>{step.title}</h3>
              <p>{step.detail}</p>
            </div>
            {index < CORE_LOOP_GROUPS.length - 1 && <span className="landing-loop-dots" aria-hidden="true" />}
          </React.Fragment>
        ))}

        <div className="landing-loop-repeat">
          <span>
            <Icon name="refresh-cw" size={27} />
          </span>
          <h3>Repeat</h3>
          <p>Carry the next signal forward.</p>
        </div>
      </div>

      <div className="landing-loop-return" aria-hidden="true" />
      <p className="landing-sr-only">Full loop: Orient, Observe, Choose, Test, Notice, Reflect, Decide, Integrate.</p>
    </div>
  </section>
));

LandingHowItWorks.displayName = 'LandingHowItWorks';

export default LandingHowItWorks;
